import { pxToRem } from '@group-link-one/gl-components';

import {
  exportVariables,
  type SPColorsVariables,
  type SPColorVariable,
  type SPSizeVariable,
  type SPSizeVariables,
} from '@group-link-one/gl-ui/sonarprint';

const SonarLightVariables: SPColorsVariables = {
  ACCENT: {
    ACCENT_COLOR_PRIMARY_BACKGROUND: '#00A799',
    ACCENT_COLOR_PRIMARY_TEXT: '#00A799',
    ACCENT_COLOR_PRIMARY_STROKE: '#00A799',
    ACCENT_COLOR_PRIMARY_BACKGROUND_50: '#80D3CC',
    ACCENT_COLOR_PRIMARY_TEXT_50: '#80D3CC',
    ACCENT_COLOR_PRIMARY_STROKE_50: '#80D3CC',
    ACCENT_COLOR_PRIMARY_BACKGROUND_25: '#BFE9E5',
    ACCENT_COLOR_PRIMARY_TEXT_25: '#BFE9E5',
    ACCENT_COLOR_PRIMARY_STROKE_25: '#BFE9E5',
    ACCENT_COLOR_PRIMARY_BACKGROUND_10: '#E6F7F5',
    ACCENT_COLOR_PRIMARY_STROKE_10: '#E6F7F5',
    ACCENT_COLOR_SECONDARY_BACKGROUND: '#00FFFF',
    ACCENT_COLOR_SECONDARY_TEXT: '#00FFFF',
    ACCENT_COLOR_SECONDARY_STROKE: '#00FFFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND_50: '#80FFFF',
    ACCENT_COLOR_SECONDARY_TEXT_50: '#80FFFF',
    ACCENT_COLOR_SECONDARY_STROKE_50: '#80FFFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND_25: '#BFFFFF',
    ACCENT_COLOR_SECONDARY_TEXT_25: '#BFFFFF',
    ACCENT_COLOR_SECONDARY_STROKE_25: '#BFFFFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND_10: '#E6FFFF',
    ACCENT_COLOR_SECONDARY_STROKE_10: '#E6FFFF',
    ACCENT_COLOR_TERTIARY_BACKGROUND: '#0066FF',
    ACCENT_COLOR_TERTIARY_TEXT: '#0066FF',
    ACCENT_COLOR_TERTIARY_STROKE: '#0066FF',
    ACCENT_COLOR_TERTIARY_BACKGROUND_50: '#80B3FF',
    ACCENT_COLOR_TERTIARY_TEXT_50: '#80B3FF',
    ACCENT_COLOR_TERTIARY_STROKE_50: '#80B3FF',
    ACCENT_COLOR_TERTIARY_BACKGROUND_25: '#BFCFFF',
    ACCENT_COLOR_TERTIARY_TEXT_25: '#BFCFFF',
    ACCENT_COLOR_TERTIARY_STROKE_25: '#BFCFFF',
    ACCENT_COLOR_TERTIARY_BACKGROUND_10: '#E6F0FF',
    ACCENT_COLOR_TERTIARY_STROKE_10: '#E6F0FF',
  },
  COLOR: {
    COLOR_PRIMARY_BACKGROUND: '#66FF99',
    COLOR_PRIMARY_TEXT: '#66FF99',
    COLOR_PRIMARY_STROKE: '#66FF99',
    COLOR_PRIMARY_BACKGROUND_50: '#B3FFCC',
    COLOR_PRIMARY_TEXT_50: '#B3FFCC',
    COLOR_PRIMARY_STROKE_50: '#B3FFCC',
    COLOR_PRIMARY_BACKGROUND_25: '#D8FFE5',
    COLOR_PRIMARY_TEXT_25: '#D8FFE5',
    COLOR_PRIMARY_STROKE_25: '#D8FFE5',
    COLOR_PRIMARY_BACKGROUND_10: '#F0FFF5',
    COLOR_PRIMARY_STROKE_10: '#F0FFF5',
    COLOR_SECONDARY_BACKGROUND: '#FF6033',
    COLOR_SECONDARY_TEXT: '#FF6033',
    COLOR_SECONDARY_STROKE: '#FF6033',
    COLOR_SECONDARY_BACKGROUND_50: '#FFB099',
    COLOR_SECONDARY_TEXT_50: '#FFB099',
    COLOR_SECONDARY_STROKE_50: '#FFB099',
    COLOR_SECONDARY_BACKGROUND_25: '#FFD7CC',
    COLOR_SECONDARY_TEXT_25: '#FFD7CC',
    COLOR_SECONDARY_STROKE_25: '#FFD7CC',
    COLOR_SECONDARY_BACKGROUND_10: '#FFF0EB',
    COLOR_SECONDARY_STROKE_10: '#FFF0EB',
    COLOR_TERTIARY_BACKGROUND: '#003366',
    COLOR_TERTIARY_TEXT: '#003366',
    COLOR_TERTIARY_STROKE: '#003366',
    COLOR_TERTIARY_BACKGROUND_50: '#8099B3',
    COLOR_TERTIARY_STROKE_50: '#8099B3',
    COLOR_TERTIARY_BACKGROUND_25: '#BFCCD8',
    COLOR_TERTIARY_STROKE_25: '#BFCCD8',
    COLOR_TERTIARY_BACKGROUND_10: '#E6EBF0',
    COLOR_TERTIARY_STROKE_10: '#E6EBF0',
    COLOR_QUATERNARY_BACKGROUND: '#262626',
    COLOR_QUINARY_BACKGROUND: '#FFFFFF',
  },
  BASE: {
    BASE_COLOR_PRIMARY_BACKGROUND: '#313337',
    BASE_COLOR_PRIMARY_TEXT: '#313337',
    BASE_COLOR_PRIMARY_STROKE: '#313337',
    BASE_COLOR_SECONDARY_BACKGROUND: '#58616A',
    BASE_COLOR_SECONDARY_TEXT: '#58616A',
    BASE_COLOR_SECONDARY_STROKE: '#58616A',
    BASE_COLOR_TERTIARY_BACKGROUND: '#888E9E',
    BASE_COLOR_TERTIARY_TEXT: '#888E9E',
    BASE_COLOR_TERTIARY_STROKE: '#888E9E',
    BASE_COLOR_QUATERNARY_BACKGROUND: '#B2BDC5',
    BASE_COLOR_QUATERNARY_TEXT: '#B2BDC5',
    BASE_COLOR_QUATERNARY_STROKE: '#B2BDC5',
    BASE_COLOR_QUINARY_BACKGROUND: '#E2E8EF',
    BASE_COLOR_QUINARY_TEXT: '#E2E8EF',
    BASE_COLOR_QUINARY_STROKE: '#E2E8EF',
    BASE_COLOR_SENARY_BACKGROUND: '#F5F8F9',
    BASE_COLOR_SENARY_TEXT: '#F5F8F9',
    BASE_COLOR_SENARY_STROKE: '#F5F8F9',
  },
  WARNING: {
    WARNING_COLOR_PRIMARY_BACKGROUND: '#00893C',
    WARNING_COLOR_PRIMARY_TEXT: '#00893C',
    WARNING_COLOR_PRIMARY_STROKE: '#00893C',
    WARNING_COLOR_PRIMARY_BACKGROUND_90: '#1A9550',
    WARNING_COLOR_PRIMARY_STROKE_90: '#1A9550',
    WARNING_COLOR_PRIMARY_BACKGROUND_75: '#40A76D',
    WARNING_COLOR_PRIMARY_STROKE_75: '#40A76D',
    WARNING_COLOR_PRIMARY_BACKGROUND_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_STROKE_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_BACKGROUND_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_STROKE_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_BACKGROUND_10: '#E6F4EC',
    WARNING_COLOR_PRIMARY_STROKE_10: '#E6F4EC',
    WARNING_COLOR_SECONDARY_BACKGROUND: '#E4A700',
    WARNING_COLOR_SECONDARY_TEXT: '#E4A700',
    WARNING_COLOR_SECONDARY_STROKE: '#E4A700',
    WARNING_COLOR_SECONDARY_BACKGROUND_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_STROKE_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_BACKGROUND_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_STROKE_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_BACKGROUND_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_STROKE_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_BACKGROUND_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_STROKE_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_BACKGROUND_10: '#FDF7E6',
    WARNING_COLOR_SECONDARY_STROKE_10: '#FDF7E6',
    WARNING_COLOR_TERTIARY_BACKGROUND: '#E12C57',
    WARNING_COLOR_TERTIARY_TEXT: '#E12C57',
    WARNING_COLOR_TERTIARY_STROKE: '#E12C57',
    WARNING_COLOR_TERTIARY_BACKGROUND_90: '#E44268',
    WARNING_COLOR_TERTIARY_STROKE_90: '#E44268',
    WARNING_COLOR_TERTIARY_BACKGROUND_75: '#E96181',
    WARNING_COLOR_TERTIARY_STROKE_75: '#E96181',
    WARNING_COLOR_TERTIARY_BACKGROUND_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_STROKE_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_BACKGROUND_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_STROKE_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_BACKGROUND_10: '#FCEAEF',
    WARNING_COLOR_TERTIARY_STROKE_10: '#FCEAEF',
  },
};

const SonarDarkVariables: SPColorsVariables = {
  ACCENT: {
    ACCENT_COLOR_PRIMARY_BACKGROUND: '#00A799',
    ACCENT_COLOR_PRIMARY_TEXT: '#00A799',
    ACCENT_COLOR_PRIMARY_STROKE: '#00A799',
    ACCENT_COLOR_PRIMARY_BACKGROUND_50: '#80D3CC',
    ACCENT_COLOR_PRIMARY_TEXT_50: '#80D3CC',
    ACCENT_COLOR_PRIMARY_STROKE_50: '#80D3CC',
    ACCENT_COLOR_PRIMARY_BACKGROUND_25: '#BFE9E5',
    ACCENT_COLOR_PRIMARY_TEXT_25: '#BFE9E5',
    ACCENT_COLOR_PRIMARY_STROKE_25: '#BFE9E5',
    ACCENT_COLOR_PRIMARY_BACKGROUND_10: '#E6F7F5',
    ACCENT_COLOR_PRIMARY_STROKE_10: '#E6F7F5',
    ACCENT_COLOR_SECONDARY_BACKGROUND: '#00FFFF',
    ACCENT_COLOR_SECONDARY_TEXT: '#00FFFF',
    ACCENT_COLOR_SECONDARY_STROKE: '#00FFFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND_50: '#80FFFF',
    ACCENT_COLOR_SECONDARY_TEXT_50: '#80FFFF',
    ACCENT_COLOR_SECONDARY_STROKE_50: '#80FFFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND_25: '#BFFFFF',
    ACCENT_COLOR_SECONDARY_TEXT_25: '#BFFFFF',
    ACCENT_COLOR_SECONDARY_STROKE_25: '#BFFFFF',
    ACCENT_COLOR_SECONDARY_BACKGROUND_10: '#E6FFFF',
    ACCENT_COLOR_SECONDARY_STROKE_10: '#E6FFFF',
    ACCENT_COLOR_TERTIARY_BACKGROUND: '#0066FF',
    ACCENT_COLOR_TERTIARY_TEXT: '#0066FF',
    ACCENT_COLOR_TERTIARY_STROKE: '#0066FF',
    ACCENT_COLOR_TERTIARY_BACKGROUND_50: '#80B3FF',
    ACCENT_COLOR_TERTIARY_TEXT_50: '#80B3FF',
    ACCENT_COLOR_TERTIARY_STROKE_50: '#80B3FF',
    ACCENT_COLOR_TERTIARY_BACKGROUND_25: '#BFCFFF',
    ACCENT_COLOR_TERTIARY_TEXT_25: '#BFCFFF',
    ACCENT_COLOR_TERTIARY_STROKE_25: '#BFCFFF',
    ACCENT_COLOR_TERTIARY_BACKGROUND_10: '#E6F0FF',
    ACCENT_COLOR_TERTIARY_STROKE_10: '#E6F0FF',
  },
  COLOR: {
    COLOR_PRIMARY_BACKGROUND: '#66FF99',
    COLOR_PRIMARY_TEXT: '#66FF99',
    COLOR_PRIMARY_STROKE: '#66FF99',
    COLOR_PRIMARY_BACKGROUND_50: '#B3FFCC',
    COLOR_PRIMARY_TEXT_50: '#B3FFCC',
    COLOR_PRIMARY_STROKE_50: '#B3FFCC',
    COLOR_PRIMARY_BACKGROUND_25: '#D8FFE5',
    COLOR_PRIMARY_TEXT_25: '#D8FFE5',
    COLOR_PRIMARY_STROKE_25: '#D8FFE5',
    COLOR_PRIMARY_BACKGROUND_10: '#F0FFF5',
    COLOR_PRIMARY_STROKE_10: '#F0FFF5',
    COLOR_SECONDARY_BACKGROUND: '#FF6033',
    COLOR_SECONDARY_TEXT: '#FF6033',
    COLOR_SECONDARY_STROKE: '#FF6033',
    COLOR_SECONDARY_BACKGROUND_50: '#FFB099',
    COLOR_SECONDARY_TEXT_50: '#FFB099',
    COLOR_SECONDARY_STROKE_50: '#FFB099',
    COLOR_SECONDARY_BACKGROUND_25: '#FFD7CC',
    COLOR_SECONDARY_TEXT_25: '#FFD7CC',
    COLOR_SECONDARY_STROKE_25: '#FFD7CC',
    COLOR_SECONDARY_BACKGROUND_10: '#FFF0EB',
    COLOR_SECONDARY_STROKE_10: '#FFF0EB',
    COLOR_TERTIARY_BACKGROUND: '#003366',
    COLOR_TERTIARY_TEXT: '#003366',
    COLOR_TERTIARY_STROKE: '#003366',
    COLOR_TERTIARY_BACKGROUND_50: '#8099B3',
    COLOR_TERTIARY_STROKE_50: '#8099B3',
    COLOR_TERTIARY_BACKGROUND_25: '#BFCCD8',
    COLOR_TERTIARY_STROKE_25: '#BFCCD8',
    COLOR_TERTIARY_BACKGROUND_10: '#E6EBF0',
    COLOR_TERTIARY_STROKE_10: '#E6EBF0',
    COLOR_QUATERNARY_BACKGROUND: '#262626',
    COLOR_QUINARY_BACKGROUND: '#FFFFFF',
  },
  BASE: {
    BASE_COLOR_PRIMARY_BACKGROUND: '#313337',
    BASE_COLOR_PRIMARY_TEXT: '#313337',
    BASE_COLOR_PRIMARY_STROKE: '#313337',
    BASE_COLOR_SECONDARY_BACKGROUND: '#58616A',
    BASE_COLOR_SECONDARY_TEXT: '#58616A',
    BASE_COLOR_SECONDARY_STROKE: '#58616A',
    BASE_COLOR_TERTIARY_BACKGROUND: '#888E9E',
    BASE_COLOR_TERTIARY_TEXT: '#888E9E',
    BASE_COLOR_TERTIARY_STROKE: '#888E9E',
    BASE_COLOR_QUATERNARY_BACKGROUND: '#B2BDC5',
    BASE_COLOR_QUATERNARY_TEXT: '#B2BDC5',
    BASE_COLOR_QUATERNARY_STROKE: '#B2BDC5',
    BASE_COLOR_QUINARY_BACKGROUND: '#E2E8EF',
    BASE_COLOR_QUINARY_TEXT: '#E2E8EF',
    BASE_COLOR_QUINARY_STROKE: '#E2E8EF',
    BASE_COLOR_SENARY_BACKGROUND: '#F5F8F9',
    BASE_COLOR_SENARY_TEXT: '#F5F8F9',
    BASE_COLOR_SENARY_STROKE: '#F5F8F9',
  },
  WARNING: {
    WARNING_COLOR_PRIMARY_BACKGROUND: '#00893C',
    WARNING_COLOR_PRIMARY_TEXT: '#00893C',
    WARNING_COLOR_PRIMARY_STROKE: '#00893C',
    WARNING_COLOR_PRIMARY_BACKGROUND_90: '#1A9550',
    WARNING_COLOR_PRIMARY_STROKE_90: '#1A9550',
    WARNING_COLOR_PRIMARY_BACKGROUND_75: '#40A76D',
    WARNING_COLOR_PRIMARY_STROKE_75: '#40A76D',
    WARNING_COLOR_PRIMARY_BACKGROUND_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_STROKE_50: '#7FC39D',
    WARNING_COLOR_PRIMARY_BACKGROUND_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_STROKE_25: '#BFE1CE',
    WARNING_COLOR_PRIMARY_BACKGROUND_10: '#E6F4EC',
    WARNING_COLOR_PRIMARY_STROKE_10: '#E6F4EC',
    WARNING_COLOR_SECONDARY_BACKGROUND: '#E4A700',
    WARNING_COLOR_SECONDARY_TEXT: '#E4A700',
    WARNING_COLOR_SECONDARY_STROKE: '#E4A700',
    WARNING_COLOR_SECONDARY_BACKGROUND_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_STROKE_90: '#E7B01A',
    WARNING_COLOR_SECONDARY_BACKGROUND_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_STROKE_75: '#EBBD40',
    WARNING_COLOR_SECONDARY_BACKGROUND_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_STROKE_50: '#F1D27F',
    WARNING_COLOR_SECONDARY_BACKGROUND_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_STROKE_25: '#F8E9BF',
    WARNING_COLOR_SECONDARY_BACKGROUND_10: '#FDF7E6',
    WARNING_COLOR_SECONDARY_STROKE_10: '#FDF7E6',
    WARNING_COLOR_TERTIARY_BACKGROUND: '#E12C57',
    WARNING_COLOR_TERTIARY_TEXT: '#E12C57',
    WARNING_COLOR_TERTIARY_STROKE: '#E12C57',
    WARNING_COLOR_TERTIARY_BACKGROUND_90: '#E44268',
    WARNING_COLOR_TERTIARY_STROKE_90: '#E44268',
    WARNING_COLOR_TERTIARY_BACKGROUND_75: '#E96181',
    WARNING_COLOR_TERTIARY_STROKE_75: '#E96181',
    WARNING_COLOR_TERTIARY_BACKGROUND_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_STROKE_50: '#EF95AA',
    WARNING_COLOR_TERTIARY_BACKGROUND_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_STROKE_25: '#F7CAD5',
    WARNING_COLOR_TERTIARY_BACKGROUND_10: '#FCEAEF',
    WARNING_COLOR_TERTIARY_STROKE_10: '#FCEAEF',
  },
};

const SonarSizeVariables: SPSizeVariables = {
  SPACING: {
    BASE: '16px',
    XXS: '2px',
    XS: '4px',
    S: '6px',
    SM: '10px',
    M: '14px',
    ML: '20px',
    L: '28px',
    XL: '40px',
  },
  RADIUS: {
    SHARP: '0px',
    XXS: '2px',
    XS: '2px',
    S: '4px',
    SM: '6px',
    M: '10px',
    ML: '16px',
    LG: '24px',
    XL: '36px',
    ROUND: '50%',
  },
  FONT_SIZE: {
    HEADLINE_1: pxToRem('83px'),
    HEADLINE_2: pxToRem('69px'),
    HEADLINE_3: pxToRem('57px'),
    HEADLINE_4: pxToRem('48px'),
    HEADLINE_5: pxToRem('40px'),
    HEADLINE_6: pxToRem('33px'),
    SUBTITLE_1: pxToRem('28px'),
    SUBTITLE_2: pxToRem('23px'),
    BODY_1: pxToRem('19px'),
    BODY_2: pxToRem('16px'),
    CAPTION: pxToRem('13px'),
    OVERLINE: pxToRem('11px'),
  },
};

const lightVariablesArr: SPColorVariable[] = exportVariables(SonarLightVariables);
const darkVariablesArr: SPColorVariable[] = exportVariables(SonarDarkVariables);

const sizeVariablesArr: SPSizeVariable[] = exportVariables(SonarSizeVariables, true);
export { lightVariablesArr, darkVariablesArr, sizeVariablesArr };
